import { defineComponent } from 'vue'

/**
 * CATableRow
 * @component CATableRow
 *
 * @prop {String} [id=''] - The unique identifier for the table row.
 * @prop {String} [dataTest='ca-table-row'] - The data-test attribute for the table row.
 *
 * @emit click - Emits when the row is clicked.
 *
 * @slot default - The default slot for the table row.
 *
 */
export default defineComponent({
	name: 'CATableRow',

	props: {
		/**
		 * The data-test attribute for the table row.
		 * @default 'ca-table-row'
		 * @type {String}
		 */
		dataTest: { default: 'ca-table-row', type: String },
		/**
		 * The unique identifier for the table row.
		 * @default ''
		 * @type {String}
		 */
		id: { default: '', type: String },
	},

	emits: ['click'],

	methods: {
		handleClick() {
			this.$emit('click')
		},
	},

	render() {
		return (
			<tr
				class="ca-table__row"
				data-test={this.dataTest}
				id={this.id}
				onClick={this.handleClick}
			>
				{this.$slots.default?.()}
			</tr>
		)
	},
})
